import { render, staticRenderFns } from "./AdminCalendar.vue?vue&type=template&id=bc96c732&scoped=true"
import script from "./AdminCalendar.vue?vue&type=script&lang=js"
export * from "./AdminCalendar.vue?vue&type=script&lang=js"
import style0 from "./AdminCalendar.vue?vue&type=style&index=0&id=bc96c732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc96c732",
  null
  
)

export default component.exports